/**
 * Canonicalls public product hosts — human-facing continuity layer (XO is substrate).
 */
import { normalizeHostname } from "./host_root_landing";

export const CANONICALLS_HOSTS = new Set([
  "canonicalls.com",
  "www.canonicalls.com",
  "canonicall.com",
  "www.canonicall.com",
]);

export const CANONICALLS_PUBLIC_PATHS = [
  "/",
  "/canonicalize",
  "/inspect",
  "/replay",
  "/aether",
] as const;

/** Path-owned routes — win over host fallback (preview hosts, xo.watch, etc.). */
export const CANONICALLS_OWNED_PATH_PREFIXES = [
  "/canonicalize",
  "/inspect",
  "/replay",
  "/aether",
] as const;

export type CanonicallsPublicPath = (typeof CANONICALLS_PUBLIC_PATHS)[number];

export function normalizeCanonicallsPathname(pathname: string): string {
  return pathname.replace(/\/$/, "") || "/";
}

export function isCanonicallsHost(hostname: string): boolean {
  return CANONICALLS_HOSTS.has(normalizeHostname(hostname));
}

export function isCanonicallsPublicPath(pathname: string): boolean {
  const p = normalizeCanonicallsPathname(pathname);
  return (CANONICALLS_PUBLIC_PATHS as readonly string[]).includes(p);
}

/** True when URL path is owned by Canonicalls (not legacy /cross-post). */
export function isCanonicallsOwnedPath(pathname: string): boolean {
  const p = normalizeCanonicallsPathname(pathname);
  return CANONICALLS_OWNED_PATH_PREFIXES.some(
    (prefix) => p === prefix || p.startsWith(`${prefix}/`),
  );
}

/** Hide XO sidebar / traversal chrome — full Canonicalls shell. */
export function shouldUseCanonicallsShell(hostname: string, pathname: string): boolean {
  if (isCanonicallsOwnedPath(pathname)) return true;
  if (isCanonicallsHost(hostname)) return true;
  return false;
}

export function canonicallsPathForXoAlias(pathname: string): string | null {
  const p = normalizeCanonicallsPathname(pathname);
  if (p === "/cross-post") return "/canonicalize";
  return null;
}

/**
 * @deprecated Path-owned routes never redirect to legacy /cross-post.
 */
export function xoPathForCanonicallsRoute(_pathname: string): string | null {
  return null;
}
